<script setup>
import CalculatorParamBases from './CalculatorParamBases.vue';
import CalculatorParamPeriod from './CalculatorParamPeriod.vue';
import CalculatorParamProgram from './CalculatorParamProgram.vue';
import CalculatorParamTariff from './CalculatorParamTariff.vue';
import CalculatorParamUsers from './CalculatorParamUsers.vue';
</script>

<template>
  <div class="cloud-calculator__params">
    <CalculatorParamProgram/>
    <CalculatorParamUsers/>
    <CalculatorParamBases/>
    <CalculatorParamPeriod/>
    <CalculatorParamTariff/>
  </div>
</template>
